import { UserActionTypes } from './user.action.types'

export const setCurrentUser = (userData) => ({
    type : UserActionTypes.SET_CURRENT_USER,
    payload : {
        userData
    }
})